export default function flatten(input) {
  return input.reduce((res, el) => res.concat(Array.isArray(el) ? flatten(el) : [el]), [])
}